import { campaignStore } from '@/stores';

/**
 * Mirrors Cyrian-Backend `DEFAULT_CAMPAIGN_SEASON`: main crop wraps Oct→Mar,
 * mid crop Apr→Sep. Operators can adjust before submit.
 */
const DEFAULT_SEASON = {
  mainStartMonth: 10,
  mainStartDay: 1,
  mainEndMonth: 3,
  mainEndDay: 31,
  midStartMonth: 4,
  midStartDay: 1,
  midEndMonth: 9,
  midEndDay: 30,
} as const;

/**
 * Anchor year for the next campaign. Uses `max(existing.year) + 1` from the
 * cached store so defaults do not collide with rows already in DB. Empty store
 * falls back to the anchor that contains today under the default wrap windows
 * (Jan–Sep → year-1, Oct–Dec → year).
 */
function nextAnchorYear(now: Date): number {
  const fromStore = campaignStore.items.map((c) => parseInt(String(c.year), 10)).filter((n) => Number.isFinite(n));
  if (fromStore.length > 0) {
    return Math.max(...fromStore) + 1;
  }
  return now.getMonth() >= 9 ? now.getFullYear() : now.getFullYear() - 1;
}

/** Initial values for "Create campaign" (operator can edit before submit). */
export function getDefaultCampaignCreateValues(): Partial<cyrian.api.campaigns.CampaignParams> {
  const y = nextAnchorYear(new Date());
  return {
    name: `[${y} - ${y + 1}] Campaign`,
    year: String(y),
    ...DEFAULT_SEASON,
  };
}
